import './App.css';
import "./bootstrap.min.css"
import { Routes, Route, Navigate } from 'react-router-dom';
import NotFound from './screens/NotFound';
import ComingSoon from './screens/ComingSoon';
import Home from './screens/Home';
import ElastronFabric from './screens/ElastronFabric';
import ThreeMDiNOC from './screens/ThreeMDiNOC';
import ThreeDDecorativeWalls from './screens/ThreeDDecorativeWalls';
import Contact from './screens/Contact';
import TermsCondition from './screens/TermsCondition';
import ThankYou from './screens/ThankYou';
import PartnershipOpportunities from './screens/PartnershipOpportunities';
import LoginScreen from "./AdminScreens/LoginScreen";
import BlogsScreen from "./AdminScreens/BlogsScreens/BlogsScreen";
import AdminScreen from "./AdminScreens/AdminScreen";
import LocationScreen from './screens/LocationScreens/LocationScreen';
import LocationPages from "./component/LocationPages_/LocationPages"
import BlogInner from './screens/BlogInner';
import News from './screens/News';



function App() {
  return (
    <div>
      <Routes>
        {/* <Route path="/" element={<ComingSoon />} /> */}
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/elastron-fabric" element={<ElastronFabric />} />
        <Route path="/3m-di-noc" element={<ThreeMDiNOC />} />
        <Route path="/3d-decorative-walls" element={<ThreeDDecorativeWalls />} />
        <Route path="/partnership-opportunities" element={<PartnershipOpportunities />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms-condition" element={<TermsCondition />} />
        <Route path="/thank-you" element={<ThankYou />} />

        <Route path="/blog" element={<News />} />
        <Route path="/artical/:id" element={<BlogInner />} />
       
        <Route path="*" element={<NotFound />} />

          <Route path="/admin" element={<AdminScreen />} />
        <Route path="/admin/blogs" element={<BlogsScreen />} />
        <Route path="/login" element={<LoginScreen />} />
        
        <Route path='/location/:slug' element={<LocationPages />} />
        <Route path='/admin/location-pages' element={<LocationScreen />}/>
      </Routes>
    </div>
  );
}

export default App;


